import { Factory } from "@/data/dao/Factory";
import { CatalogDao } from "@/data/dao/service/CatalogDao";
import type { IAttribute } from "@/data/model/Attribute";
import { Format } from "@/data/util/Format";

import { BaseTabbedController } from "@/portal/controller/BaseTabbedController";
import { AttributeForm } from "@/portal/forms/AttributeForm";
import { TastierGlobal } from "@/portal/globalAccess";

export class AttributeController extends BaseTabbedController<IAttribute> {
    private attributeForm: AttributeForm;

    constructor(element: JQuery) {
        super(element, Factory.getInstance<CatalogDao>(CatalogDao).attributeDataSource);

        this.attributeForm = new AttributeForm(this.formContentByTabName("attributeedit"));
        this.registerModelForm(this.attributeForm);
    }

    protected onModelLoaded(m?: IAttribute) {
        if (m === undefined) {
            const vw = $("#kt_header > #kt_header_menu_wrapper");
            if (vw.find("> .selectedlocation").length === 0)
                vw.append(
                    '<div class="selectedlocation">' +
                        Format.htmlEscape(TastierGlobal.getLocationSwitch()!.getCurrentLocationName()) +
                        "</div>"
                );
        }

        this.attributeForm.setData(m);
    }
}
